const CalendarIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.66699C10.9205 1.66699 11.6667 2.41318 11.6667 3.33366V3.48654C11.2079 3.52492 10.7722 3.57294 10.3589 3.633C9.6426 3.73712 8.96725 3.88068 8.33337 4.08174V3.33366C8.33337 2.41318 9.07957 1.66699 10 1.66699Z"
        fill="#0051FF"
      />
      <path
        d="M29.6412 3.633C30.3575 3.73712 31.0328 3.88068 31.6667 4.08174V3.33366C31.6667 2.41318 30.9205 1.66699 30 1.66699C29.0796 1.66699 28.3334 2.41318 28.3334 3.33366V3.48654C28.7922 3.52492 29.2279 3.57294 29.6412 3.633Z"
        fill="#0051FF"
      />
      <path
        d="M18.3334 20.0003C17.4129 20.0003 16.6667 20.7465 16.6667 21.667C16.6667 22.5875 17.4129 23.3337 18.3334 23.3337H26.6667C27.5872 23.3337 28.3334 22.5875 28.3334 21.667C28.3334 20.7465 27.5872 20.0003 26.6667 20.0003H18.3334Z"
        fill="#0051FF"
      />
      <path
        d="M13.3334 20.0003C12.4129 20.0003 11.6667 20.7465 11.6667 21.667C11.6667 22.5875 12.4129 23.3337 13.3334 23.3337H13.3483C14.2688 23.3337 15.015 22.5875 15.015 21.667C15.015 20.7465 14.2688 20.0003 13.3483 20.0003H13.3334Z"
        fill="#0051FF"
      />
      <path
        d="M13.3334 26.667C12.4129 26.667 11.6667 27.4132 11.6667 28.3337C11.6667 29.2541 12.4129 30.0003 13.3334 30.0003H21.6667C22.5872 30.0003 23.3334 29.2541 23.3334 28.3337C23.3334 27.4132 22.5872 26.667 21.6667 26.667H13.3334Z"
        fill="#0051FF"
      />
      <path
        d="M26.6517 26.667C25.7313 26.667 24.9851 27.4132 24.9851 28.3337C24.9851 29.2541 25.7313 30.0003 26.6517 30.0003H26.6667C27.5872 30.0003 28.3334 29.2541 28.3334 28.3337C28.3334 27.4132 27.5872 26.667 26.6667 26.667H26.6517Z"
        fill="#0051FF"
      />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7146 3.33301H18.2854C15.0382 3.33296 12.419 3.33291 10.3589 3.63235C8.20891 3.94484 6.428 4.6127 5.03003 6.12401C3.64915 7.61685 3.05465 9.48754 2.7736 11.7474C2.49994 13.9479 2.49997 16.7565 2.5 20.2895V21.3765C2.49997 24.9095 2.49994 27.7181 2.7736 29.9186C3.05465 32.1785 3.64915 34.0492 5.03003 35.542C6.428 37.0533 8.20891 37.7212 10.3589 38.0337C12.419 38.3331 15.0382 38.3331 18.2854 38.333H21.7146C24.9618 38.3331 27.581 38.3331 29.6411 38.0337C31.7911 37.7212 33.572 37.0533 34.97 35.542C36.3508 34.0492 36.9454 32.1785 37.2264 29.9186C37.5001 27.7181 37.5 24.9095 37.5 21.3765V20.2895C37.5 16.7565 37.5001 13.9479 37.2264 11.7474C36.9454 9.48754 36.3508 7.61685 34.97 6.12401C33.572 4.6127 31.7911 3.94484 29.6411 3.63235C27.581 3.33291 24.9618 3.33296 21.7146 3.33301ZM7.49638 14.9997C6.73201 14.9997 6.34983 14.9997 6.10642 15.24C5.86301 15.4802 5.85812 15.8575 5.84834 16.6122C5.83379 17.7341 5.83334 18.99 5.83334 20.4051V21.2609C5.83334 24.9357 5.83637 27.5365 6.08145 29.5072C6.32212 31.4424 6.77105 32.5153 7.47703 33.2785C8.16593 34.0233 9.10783 34.4835 10.8383 34.735C12.631 34.9956 15.0071 34.9997 18.4167 34.9997H21.5833C24.9929 34.9997 27.369 34.9956 29.1617 34.735C30.8922 34.4835 31.8341 34.0233 32.523 33.2785C33.229 32.5153 33.6779 31.4424 33.9185 29.5072C34.1636 27.5365 34.1667 24.9357 34.1667 21.2609V20.4051C34.1667 18.99 34.1662 17.7341 34.1517 16.6122C34.1419 15.8575 34.137 15.4802 33.8936 15.24C33.6502 14.9997 33.268 14.9997 32.5036 14.9997H7.49638Z"
        fill="#0051FF"
      />
    </svg>
  );
};

export default CalendarIcon;
